import { Form, Button, Col, Row, Card, InputGroup, Tooltip, OverlayTrigger, Table, Modal } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import Amount from '../../core/Amount';
import React, { useEffect, useState } from 'react';
import InfoTooltip from '../../core/ToolTip';
import axios from "axios";
import { Link, useSearchParams, useParams } from "react-router-dom";
import { SpinnerModal, blockInvalidAmount, blockInvalidChar, blockInvalidPercent } from '../Util';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
export default function FiscalMuseumResponse() {

    const navigate = useNavigate();
    const FISCAL_BASE_URL = process.env.REACT_APP_FISCAL_BASE_URL;
    const FISCAL_POST = process.env.REACT_APP_FISCAL_POST;
    const FISCAL_PUT = process.env.REACT_APP_FISCAL_PUT;
    const FISCAL_GET_ID = process.env.REACT_APP_FISCAL_GET_ID;
    const data = {
        income: {
            grossSales: "",
            shippingHandlingFees: "",
            salesReturns: "",
            salesDiscounts: "",
            salesTax: "",
            netSales: "",
            percentNetSales: "",
        },
        costGoodsSold: {
            goodsSold: "",
            freightIn: "",
            totalCostOfGoodsSold: "",
            percentNetSales: "",
            grossProfit: ""
        },
        operationExpenses: {
            payroll: {
                wagesSalaries: "",
                benefits: "",
                empPayTaxes: "",
                totalPayExpenses: "",
                percentNetExpense: ""
            },
            other: {
                supplies: "",
                freightOut: "",
                postage: "",
                totalOperatingExpenses: "",
                percentNetIncome: ""
            },

        },
        inventoryMethod: "",
        retailaCalculations: {
            salesPerTrans: "",
            captureRate: "",
            grossMargin: "",
            turnRate: "",
            inventorySalesRatio: "",
            daysInventory: "",
            valueOfInventory: ""
        }

    }

    const museumSchema = Yup.object({
        income: Yup.object({
            grossSales: Yup.string().required('Gross Sales is required!'),
            shippingHandlingFees: Yup.string().required('Shipping & Handling Fees is required!'),
            salesReturns: Yup.string().required('Sales Returns required!'),
            salesDiscounts: Yup.string().required('Sales Discount is required!'),
            salesTax: Yup.string().required('Sales tax is required!'),
            netSales: Yup.string().required('Net Sales is required!'),
            percentNetSales: Yup.string().required('Percentage of Net Sales is required!'),
        }),
        costGoodsSold: Yup.object({
            goodsSold: Yup.string().required('Gross Sales is required!'),
            freightIn: Yup.string().required('Gross Sales is required!'),
            totalCostOfGoodsSold: Yup.string().required('Gross Sales is required!'),
            percentNetSales: Yup.string().required('Gross Sales is required!'),
            grossProfit: Yup.string().required('Gross Sales is required!')
        }),
        operationExpenses: Yup.object({
            payroll: Yup.object({
                wagesSalaries: Yup.string().required('Gross Sales is required!'),
                benefits: Yup.string().required('Gross Sales is required!'),
                empPayTaxes: Yup.string().required('Gross Sales is required!'),
                totalPayTaxes: Yup.string().required('Gross Sales is required!'),
                percentNetExpense: Yup.string().required('Gross Sales is required!')
            }),
            other: Yup.object({
                supplies: Yup.string().required('Gross Sales is required!'),
                freightOut: Yup.string().required('Gross Sales is required!'),
                postage: Yup.string().required('Gross Sales is required!'),
                totalOperatingExpenses: Yup.string().required('Gross Sales is required!'),
                percentNetIncome: Yup.string().required('Gross Sales is required!')
            }),
        }),
        inventoryMethod: Yup.string().required('Gross Sales is required!'),
        retailaCalculations: Yup.object({
            salesPerTrans: Yup.string().required('Gross Sales is required!'),
            captureRate: Yup.string().required('Gross Sales is required!'),
            grossMargin: Yup.string().required('Gross Sales is required!'),
            turnRate: Yup.string().required('Gross Sales is required!'),
            inventorySalesRatio: Yup.string().required('Gross Sales is required!'),
            daysInventory: Yup.string().required('Gross Sales is required!'),
            valueOfInventory: Yup.string().required('Gross Sales is required!')
        })

    })
    const museumForm = useFormik({
        initialValues: data,
        validationSchema: museumSchema,
        onClick: (values) => {

        }
    });

    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const profile = JSON.parse(storedUser);
            setUserRole(profile.role);
        }
    }, []);

    const [fiscalFormData, setFiscalFormData] = useState();
    const [formData, setFormData] = useState(data);
    const [showValidationError, setShowValidationError] = useState(false);
    // Show , Hide alert after save/submit
    const [show, setShow] = useState(false);
    const [successId, setSuccessId] = useState('');
    // Alert message after save/submit
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pagePath, setPagePath] = useState('');


    const { id } = useParams();
    console.log("initial id" + id);
    useEffect(() => {
        fetchData(id);
    }, [id]);

    const fetchData = (id) => {
        console.log("initial id" + id);
        console.log(id);
        if (id) {
            setSpinnerShow(true);
            const url = FISCAL_BASE_URL + id + FISCAL_GET_ID;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    console.log('response:' + data.siteName);
                    console.log('expenditures.splEventAmount:' + data.expenditures.splEventAmount);
                    setFiscalFormData(data);
                    museumForm.setValues(data.museumStore);
                    setSpinnerShow(false);

                })
        }
    }


    const handleInputChange = (e) => {

        const { name, value } = e.target;
        console.log(`name:${name}, value:${value}`);
        const [group, ...keys] = name.split('.');
        console.log(`group:${group}, keys:${keys}`);
        if (keys.length > 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];
            console.log(`currentLevel: ${currentLevel}`);
            keys.forEach((key, index) => {
                console.log(`key: ${key}, index: ${index}`);
                if (index === keys.length - 1) {
                    // Allow only 2 decimal values
                    const re = /^\d+(\.\d{0,2})?$/;
                    if (value === '' || re.test(value)) {
                        currentLevel[key] = value;
                    }
                    // currentLevel[key] = value;

                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }
            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });
        }


    };
    const [saveShow, setSaveShow] = useState(false);

    const handleSaveClose = () => setSaveShow(false);

    const SaveModal = () => {
        return (
            <Modal
                show={saveShow}
                onHide={handleSaveClose}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure, you want to Save! This will not be available for PHMC to review.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSaveClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" name="save" onClick={handleSubmission}>Yes</Button>
                </Modal.Footer>
            </Modal>
        );
    }


    const handleSubmission = (e) => {
        const action = e.target.name;
        console.log(action);
        // closing Modal
        if (action === 'submit') {
            fiscalFormData.status = "SUBMITTED";
            handleSubmitClose();
        }
        if (action === 'save') {
            handleSaveClose();
        }

        setSpinnerShow(true);
        e.preventDefault();
        const datetime = new Date().toISOString();
        fiscalFormData.updatedDate = datetime;
        fiscalFormData.updateddBy = "";
        fiscalFormData.museumStore = museumForm.values;
        // Call REST API to update the data
        const url = FISCAL_BASE_URL + id + FISCAL_PUT;
        axios.put(url, fiscalFormData)
            .then((response) => {
                console.log(response.status, response.data);
                setSuccessId(response.data._id);
                setShow(true);
                setFormData(data);
                setShowValidationError(false);
                // Turn off spinner
                setSpinnerShow(false);

                if (action === 'save') {
                    setAlertHeading('Saved');
                    setAlertMessage('Fiscal Record has been saved!');
                    setPagePath("/fiscalView");
                } else if (action === 'submit') {
                    setAlertHeading('Submitted');
                    setAlertMessage('PHMC will review your Fiscal submission record.');
                    setPagePath("/fiscalView");
                }


            }).catch((error) => {
                console.log(error);
                setShow(false);
                setSuccessId('');
                setAlertHeading('Error');
                setAlertMessage('Something wrong, Please try again!');
                // Turn off spinner
                setSpinnerShow(false);
            });

    }

    const SubmitModal = () => {
        return (
            <Modal
                show={submitShow}
                onHide={handleSubmitClose}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>You will not be able to make changes after submitting the data. Do you want to submit the data entered and notify PHMC?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSubmitClose}> Cancel </Button>
                    <Button variant="primary" name="submit" onClick={handleSubmission}>Yes</Button>
                </Modal.Footer>
            </Modal>
        );
    }
    const [submitShow, setSubmitShow] = useState(false);
    const handleSubmitClose = () => setSubmitShow(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        const url = `${FISCAL_BASE_URL}${fiscalFormData._id}${FISCAL_PUT}`;
        console.log(fiscalFormData);
        // Call REST API to store the data
        axios.put(url, fiscalFormData
        ).then((response) => {
            console.log(response.status, response.data);
            navigate("/fiscalView");
        }).catch((error) => {
            console.log(error);
        });
    }
    const handleApprove = (e) => {
        if (fiscalFormData.status === "SUBMITTED") {
            fiscalFormData.status = "APPROVED";
            handleSubmit(e);
        }
    };
    const handleReject = (e) => {
        if (fiscalFormData.status === "SUBMITTED") {
            fiscalFormData.status = "REJECTED";
            handleSubmit(e);
        }
    };


    const [spinnerShow, setSpinnerShow] = useState(false);


    return (
        <>
            <SaveModal />
            <SubmitModal />
            Fiscal - Museum Store Data
            <div className="main-content">
                <Form className="main-content" >

                    {/* Income  */}
                    <Row className="main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Income</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} >
                                            <Form.Label>Gross Sales</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="income.grossSales" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.income.grossSales}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Gross Sales Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} >
                                            <Form.Label>Shipping & Handling Fees</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control name="income.shippingHandlingFees" disabled type="number"
                                                    value={museumForm.values.income.shippingHandlingFees}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Shipping & Handling Fees.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="income.salesReturns">
                                            <Form.Label>Sales Returns & Allowances</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="income.salesReturns" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.income.salesReturns}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Sales Returns & Allowances.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="salesDiscounts">
                                            <Form.Label>Sales Discounts</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="income.salesDiscounts" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.income.salesDiscounts}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Sales Discounts.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="salesTax">
                                            <Form.Label>Sales Tax</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="income.salesTax" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.income.salesTax}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Sales Tax.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="netSales">
                                            <Form.Label>Net Sales</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="income.netSales" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.income.netSales}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Net Sales.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="percentNetSales">
                                            <Form.Label>% of Net Sales</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="income.percentNetSales" disabled
                                                    value={museumForm.values.income.percentNetSales}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the % Net Sales.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/*   Cost of Goods Sold  */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>  Cost of Goods Sold</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="goodsSold">
                                            <Form.Label>Goods Sold/Purchased</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="costGoodsSold.goodsSold" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.costGoodsSold.goodsSold} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Goods Sold/Purchased.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="freightIn">
                                            <Form.Label>Freight-In</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="costGoodsSold.freightIn" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.costGoodsSold.freightIn} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Freight-In.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalCostOfGoodsSold">
                                            <Form.Label>Total Cost of Goods Sold</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="costGoodsSold.totalCostOfGoodsSold" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.costGoodsSold.totalCostOfGoodsSold} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Cost of Goods Sold.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="percentNetSales">
                                            <Form.Label>% of Net Sales</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="costGoodsSold.percentNetSales" disabled
                                                    onKeyDown={blockInvalidPercent} value={museumForm.values.costGoodsSold.percentNetSales} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the % of Net Sales.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="grossProfit">
                                            <Form.Label>Gross Profits</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="costGoodsSold.grossProfit" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.costGoodsSold.grossProfit} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Gross Profit.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        {/* <Tooltip id='test'> (Net sales less total cost of goods sold)</Tooltip> */}
                                        <Col />
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/*   OPERATING & OTHER EXPENSES  */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>  Operating & Other Expenses</Card.Title>
                                    <Row className="main-content" >
                                        <Col>
                                            <Card>
                                                <Card.Body>
                                                    <Card.Title>Payroll Expenses</Card.Title>
                                                    <Row className="main-content" >
                                                        <Form.Group as={Col} controlId="wagesSalaries">
                                                            <Form.Label>Wages & Salaries</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.payroll.wagesSalaries" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.payroll.wagesSalaries} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Wages & Salaries.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="benefits">
                                                            <Form.Label>Benefits</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.payroll.benefits" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.payroll.benefits} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Benefits.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="empPayTaxes">
                                                            <Form.Label>Employers Payroll Taxes</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.payroll.empPayTaxes" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.payroll.empPayTaxes} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Employers Payroll Taxes.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="main-content" >
                                                        <Form.Group as={Col} controlId="totalPayExpenses">
                                                            <Form.Label>Total Payroll Expenses</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.payroll.totalPayExpenses" disabled
                                                                    value={museumForm.values.operationExpenses.payroll.totalPayExpenses} />

                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="percentNetExpense">
                                                            <Form.Label>% of net expense</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>%</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.payroll.percentNetExpense" disabled
                                                                    onKeyDown={blockInvalidPercent} value={museumForm.values.operationExpenses.payroll.percentNetExpense} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the % of net expense.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Col></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="main-content" >
                                        <Col>
                                            <Card>
                                                <Card.Body>
                                                    <Card.Title>Other Expenses</Card.Title>
                                                    <Row className="main-content" >
                                                        {/* <Amount as={Col} label="Charge Card Fees" />
                                                        <Amount as={Col} label="Bank Charges" />
                                                        <Amount as={Col} label="Damage/Theft" /> */}
                                                        <Form.Group as={Col} controlId="supplies">
                                                            <Form.Label>Supplies</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.other.supplies" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.other.supplies} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Supplies.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="freightOut">
                                                            <Form.Label>Freight Out</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.other.freightOut" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.other.freightOut} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Freight Out.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="postage">
                                                            <Form.Label>Postage</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.other.postage" disabled
                                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.operationExpenses.other.postage} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Postage.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="main-content" >
                                                        {/* <Amount as={Col} label="Miscellaneous" /> */}
                                                        <Form.Group as={Col} controlId="totalOperatingExpenses">
                                                            <Form.Label>Total Operating Expenses</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.other.totalOperatingExpenses" disabled
                                                                    value={museumForm.values.operationExpenses.other.totalOperatingExpenses} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the Total Operating Expenses.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="percentNetIncome">
                                                            <Form.Label>% of Net Income</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text>%</InputGroup.Text>
                                                                <Form.Control type="number" name="operationExpenses.other.percentNetIncome" disabled
                                                                    onKeyDown={blockInvalidPercent} value={museumForm.values.operationExpenses.other.percentNetIncome} onChange={museumForm.handleChange}
                                                                    onBlur={museumForm.handleBlur} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter the % of Net Income.
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                        </Form.Group>
                                                        <Col />
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    {/*  Inventory Method  */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Inventory Method </Card.Title>
                                    <Form.Check type="radio" name="inventoryMethod" inline
                                        label="Average" aria-label="Average" onClick={handleInputChange} />
                                    <Form.Check type="radio" name="inventoryMethod" inline
                                        label="LIFO" aria-label="LIFO" onChange={museumForm.handleChange}
                                        onBlur={museumForm.handleBlur} />
                                    <Form.Check type="radio" name="inventoryMethod" inline
                                        label="FIFO" aria-label="FIFO" onChange={museumForm.handleChange}
                                        onBlur={museumForm.handleBlur} />
                                    <Form.Check type="radio" name="inventoryMethod" inline
                                        label="Cost of goods purchased" aria-label="Cost of goods purchased" onChange={museumForm.handleChange}
                                        onBlur={museumForm.handleBlur} />
                                    <Form.Check type="radio" name="inventoryMethod" inline
                                        label="other" aria-label="other" onChange={museumForm.handleChange}
                                        onBlur={museumForm.handleBlur} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/*  Retail Calculations */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Retail Calculations</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="salesPerTrans">
                                            <Form.Label>Sales per transaction</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.salesPerTrans" disabled
                                                    onKeyDown={blockInvalidAmount}
                                                    value={museumForm.values.retailaCalculations.salesPerTrans}
                                                    onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Sales per transaction.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="captureRate">
                                            <Form.Label>Capture Rate</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.captureRate" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.retailaCalculations.captureRate} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Capture Rate.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="grossMargin">
                                            <Form.Label>Gross Margin %</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.grossMargin" disabled
                                                    onKeyDown={blockInvalidPercent} value={museumForm.values.retailaCalculations.grossMargin} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the % of Gross Margin.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="turnRate">
                                            <Form.Label>Turn Rate</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.turnRate" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.retailaCalculations.turnRate} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Turn Rate.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>

                                    <Row className="main-content" >

                                        <Form.Group as={Col} controlId="inventorySalesRatio">
                                            <Form.Label>Inventory - Sales Ratio</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.inventorySalesRatio" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.retailaCalculations.inventorySalesRatio} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Inventory - Sales Ratio.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="daysInventory">
                                            <Form.Label>Days Inventory</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control type="number" name="retailaCalculations.daysInventory" disabled
                                                    onKeyDown={blockInvalidChar} value={museumForm.values.retailaCalculations.daysInventory} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Inventory - Sales Ratio.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="valueOfInventory">
                                            <Form.Label>Value of Inventory</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="retailaCalculations.valueOfInventory" disabled
                                                    onKeyDown={blockInvalidAmount} value={museumForm.values.retailaCalculations.valueOfInventory} onChange={museumForm.handleChange}
                                                    onBlur={museumForm.handleBlur} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Value of Inventory.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    {userRole && userRole !== 'OBSERVER' &&
                        <Row className="mb-3 main-content">

                            <Col>
                                <Row className="mb-3 submit">
                                    <Col>
                                        {fiscalFormData && fiscalFormData.status !== 'APPROVED' && (
                                            <Button variant="primary" className="m-1" onClick={handleApprove}>Approve</Button>
                                        )}

                                        <Button variant="primary" name="reject" onClick={handleReject}>  Reject </Button>

                                    </Col>
                                </Row>
                            </Col>


                            <Col />
                            <Col />
                            <Col />
                        </Row>
                    }
                    <SpinnerModal show={spinnerShow} onHide={() => setSpinnerShow(false)} />
                </Form >
            </div >
        </>
    );
}